import * as React from "react";

import { useLogin, useNotify } from "react-admin";
import { Form, Field } from "react-final-form";
import { Button } from "@material-ui/core";

const required = (value: any, fieldLabel: any) =>
	value ? undefined : `لطفا ${fieldLabel} را وارد کنید`;

export const LoginWithUserPass = () => {
	const login = useLogin();
	const notify = useNotify();
	const submit = (formValues: any) => {
		const { username, password } = formValues;
		// console.log({ username, password });
		login({
			username: username.toLowerCase(),
			password,
			LOGIN_METHOD: "login",
			service: "doctor_sale",
		}).catch((e: any) => notify(e[0]));
	};
	return (
		<Form
			onSubmit={submit}
			render={({ handleSubmit, valid }) => (
				<form onSubmit={handleSubmit}>
					<label>
						<span>نام کاربری</span>

						<Field name="username" validate={(e) => required(e, "نام کاربری")}>
							{({ input, meta }) => (
								<div style={{ margin: "0" }}>
									<input
										{...input}
										type="textbox"
										style={{ margin: "2px 0" }}
									/>
									<p
										style={{
											color: "red",
											margin: "0",
											fontSize: ".75rem",
											textAlign: "right",
										}}
									>
										{meta.touched ? meta.error : ""}
									</p>
								</div>
							)}
						</Field>
					</label>
					<label>
						<span>رمز عبور</span>

						<Field
							name="password"
							validate={(e) => required(e, "رمز عبور")}
							style={{ margin: "0" }}
						>
							{({ input, meta }) => (
								<div style={{ margin: "0" }}>
									<input
										{...input}
										type="password"
										style={{ margin: "2px 0" }}
									/>
									<p
										style={{
											color: "red",
											margin: "0",
											fontSize: ".75rem",
											textAlign: "right",
										}}
									>
										{meta.touched ? meta.error : ""}
									</p>
								</div>
							)}
						</Field>
					</label>
					<Button
						style={{ marginTop: "2rem" }}
						disabled={!valid}
						type="submit"
						variant="contained"
						color="primary"
					>
						ورود
					</Button>
				</form>
			)}
		/>
	);
};
